import { lightbox } from 'wix-window';
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(() => {
 let theItem = lightbox.getContext();  //this is the item you took from page
 let postID = theItem._id; //for the item ID in the database collection
 console.log("got item"+postID);
 $w("#Lightbox").setFilter(wixData.filter()
   .eq("_id", postID)  //we are now filtering to display only the item that matches this ID
  )
  .then(() => {
   console.log("Dataset is now filtered");
  })
  .catch((err) => {
   console.log(err);
  });

});